import React, { useState } from 'react'
import { CFormSwitch } from '@coreui/react-pro'
import GameNotificationService from 'src/service/GameNotificationService'

const TOGGLES = [
  {
    type: 'fixture',
    label: 'Completed Fixtures',
    help: 'Notify members in the app when a fixture they follow is marked complete.',
  },
  {
    type: 'trading',
    label: 'Trading Window Open',
    help: 'Notify members in the app when the trading window opens for a round.',
  },
  {
    type: 'lockout',
    label: 'Game Lockout',
    help: 'Notify members in the app when their team locks out for a round.',
  },
]

// Push-style alerts the app sends on its own - separate from the notifications created below,
// which are one-off announcements an admin writes and publishes.
const AutoNotifications = ({ settings, setSettings }) => {
  const [savingType, setSavingType] = useState(null)

  const handleChange = (type, checked) => {
    setSettings((current) => ({ ...current, [type]: checked }))
    setSavingType(type)
    GameNotificationService.changeAutoNotificationSetting({ type, value: checked })
      .then((res) => {
        if (res.status !== 200) {
          setSettings((current) => ({ ...current, [type]: !checked }))
        }
      })
      .catch(() => {
        setSettings((current) => ({ ...current, [type]: !checked }))
      })
      .finally(() => setSavingType(null))
  }

  return (
    <div>
      {TOGGLES.map(({ type, label, help }) => (
        <div className="gn-toggle-row" key={type}>
          <div>
            <p className="gn-toggle-label">{label}</p>
            <p className="gn-toggle-help">{help}</p>
          </div>
          <CFormSwitch
            size="lg"
            label={settings?.[type] ? 'On' : 'Off'}
            id={`auto_notif_${type}`}
            checked={!!settings?.[type]}
            disabled={savingType === type}
            onChange={(e) => handleChange(type, e.target.checked)}
          />
        </div>
      ))}
    </div>
  )
}

export default AutoNotifications
